import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header'; // Adjust path if needed
import Footer from './Footer';

const MainLayout = () => {
  return (
    <div className='mainlayout-container'>
      <Header />
      <div className='outlet-container'> {/* Add spacing if needed */}
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
